import { render, staticRenderFns } from "./btn-launch-app.mpx?vue&type=template&id=f248c61a&isComponent&outputPath=components%2Fbtn-launch-app6fedc000%2Findex"
import script from "./btn-launch-app.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-launch-app6fedc000%2Findex"
export * from "./btn-launch-app.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-launch-app6fedc000%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports